<template>
<div>
    <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css">
    <a @click="$emit('accepted')" :href="href" target='_blank' class="fa fa-twitter twitter"></a>
</div>
</template>

<script>
import config from '@/config'

export default {
    data() {
        return {
            href: `https://twitter.com/intent/tweet?text=${config.info.twitterShareText}, by @${config.info.teoTwitter} and @${config.info.luisTwitter}&hashtags=${config.info.threadokHashtag}&url=${location.href}`.replaceAll(' ', '%20')
        }
    }
}
</script>

<style scoped>
.twitter {
  padding: 20px;
  width: 50px;
  font-size: 20px;
  text-align: center;
  text-decoration: none;
  border-radius: 5px;
  background: #55ACEE;
  color: white;
}

.twitter:hover {
  opacity: 0.7;
}
</style>